import React from "react";
import { LearnHeader, PrevNext, Sources, absUrl, HANDLE } from "@/components/learn/common";
import { SlideViewer } from "@/components/learn/SlideViewer";
import { useLearnItem, LearnFrame, LearnFooter } from "@/pages/learn/LearnFrame";
import { useHead } from "@/lib/useHead";

function Carousel({ data }) {
  const { item, previous, next } = data;
  const url = absUrl(item.path);
  const image = absUrl(item.cover_url || item.slides?.[0]?.image_url);
  useHead({
    title: `${item.title} — ${HANDLE}`, description: item.summary || item.caption?.slice(0, 200) || item.title, image, url, type: "article",
    jsonLd: { "@context": "https://schema.org", "@type": "Article", headline: item.title, image: image ? [image] : undefined,
      datePublished: item.publish_at, mainEntityOfPage: url, author: { "@type": "Person", name: "Shubham Bapna" } },
  });
  return (
    <article className="mx-auto max-w-[760px] space-y-10 px-5 py-12" data-testid="learn-carousel-page">
      <LearnHeader item={item} kicker="Carousel" />
      <div className="mx-auto max-w-[540px]"><SlideViewer slides={item.slides || []} title={item.title} /></div>
      <section data-testid="learn-slide-text">
        <h2 className="font-heading text-lg font-bold text-ink">What's on the slides</h2>
        <ol className="mt-3 space-y-3">
          {(item.slides || []).map((s, i) => (
            <li key={i} className="flex gap-3 text-[15px] leading-relaxed text-ink">
              <span className="font-mono text-xs leading-7 text-accent">{String(i + 1).padStart(2, "0")}</span>
              <p className="whitespace-pre-line">{s.text}</p>
            </li>
          ))}
        </ol>
      </section>
      {item.caption && <p className="whitespace-pre-line rounded-[10px] border border-border bg-card p-5 text-[15px] leading-relaxed text-ink" data-testid="learn-caption">{item.caption}</p>}
      <Sources sources={item.sources} />
      <LearnFooter item={item} url={url} />
      <PrevNext previous={previous} next={next} prefix="c" label="carousel" />
    </article>
  );
}

export default function LearnCarousel() {
  const q = useLearnItem("carousel");
  return <LearnFrame query={q}>{(data) => <Carousel data={data} />}</LearnFrame>;
}
